var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultImgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h55v55H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A936F",
    d: "M0 0h55v55H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.95 20.422l4.571 4.572a1.596 1.596 0 1 0 2.257-2.257L5.468 9.426a1.35 1.35 0 0 1 1.91-1.91l10.995 10.996a1.596 1.596 0 1 0 2.257-2.257l-5.15-5.15a1.596 1.596 0 1 1 2.257-2.258l6.068 6.068c5.854-1.789 12.48-.368 17.11 4.263 5.848 5.847 6.576 14.875 2.186 21.516l4.556 4.555a1.596 1.596 0 1 1-2.257 2.258l-5.671-5.672a1.596 1.596 0 1 0-2.258 2.257l2.2 2.2a1.596 1.596 0 1 1-2.257 2.256l-1.642-1.641c-6.28 2.791-13.898 1.612-19.048-3.538a17.064 17.064 0 0 1-4.981-13.09 1.369 1.369 0 0 1-.083-.077L8.188 26.73a1.35 1.35 0 0 1 1.91-1.91l2.256 2.257a.614.614 0 1 0 .869-.868l-3.53-3.53a1.596 1.596 0 0 1 2.256-2.257zm-5.788-5.788l2.2 2.2a1.596 1.596 0 1 1-2.258 2.257l-2.199-2.2a1.596 1.596 0 0 1 2.257-2.257zm44.337 7.669a1.269 1.269 0 1 1 0-2.537 1.269 1.269 0 0 1 0 2.537zm0-.737a.532.532 0 1 0 0-1.064.532.532 0 0 0 0 1.064zM13.218 8.43a1.269 1.269 0 1 1 0-2.537 1.269 1.269 0 0 1 0 2.537zm0-.737a.532.532 0 1 0 0-1.064.532.532 0 0 0 0 1.064zm-4.092 27.01a.778.778 0 1 1 0-1.556.778.778 0 0 1 0 1.555zm0-.452a.326.326 0 1 0 0-.652.326.326 0 0 0 0 .652zm.614 8.963h.49a.246.246 0 0 1 0 .491h-.49v.491a.246.246 0 1 1-.491 0v-.49h-.492a.246.246 0 0 1 0-.492h.492v-.49a.246.246 0 0 1 .49 0v.49zM33.076 9.156h.593a.297.297 0 1 1 0 .594h-.593v.595a.295.295 0 0 1-.295.295h-.004a.295.295 0 0 1-.295-.295V9.75h-.593a.297.297 0 0 1 0-.594h.593v-.595c0-.163.132-.295.295-.295h.004c.163 0 .295.132.295.295v.595zM48.34 28.922h.348a.174.174 0 1 1 0 .348h-.348v.35a.172.172 0 0 1-.172.172h-.004a.172.172 0 0 1-.172-.172v-.35h-.348a.174.174 0 1 1 0-.348h.348v-.35c0-.095.077-.172.172-.172h.004c.095 0 .172.077.172.172v.35z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(13.259 16.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.929 9.33h6.875c.542 0 .982.44.982.982v4.911c0 .543-.44.982-.982.982H3.929a.982.982 0 0 1-.983-.982v-4.91c0-.543.44-.983.983-.983zm.49.982a.491.491 0 0 0-.49.492v3.928c0 .271.22.491.49.491h5.894c.27 0 .49-.22.49-.49v-3.93a.491.491 0 0 0-.49-.49H4.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.964 0h22.18c1.085 0 1.965.88 1.965 1.964V4.1h2.373v15.543c0 1.085-.88 1.964-1.964 1.964H1.964A1.964 1.964 0 0 1 0 19.643V1.964C0 .88.88 0 1.964 0zm.491 1.473a.982.982 0 0 0-.982.982v16.697c0 .542.44.982.982.982h23.572c-.787-.91-1.18-1.834-1.18-2.772V2.455a.982.982 0 0 0-.983-.982H2.455z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.125,
    height: 1,
    x: 2.705,
    y: 5.652,
    stroke: "#FFF",
    strokeWidth: 0.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.321,
    height: 1,
    x: 13.509,
    y: 9.58,
    stroke: "#FFF",
    strokeWidth: 0.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.411,
    height: 1,
    x: 13.509,
    y: 13.509,
    stroke: "#FFF",
    strokeWidth: 0.5,
    rx: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImgNews);
export default __webpack_public_path__ + "static/media/default_img_news.ddc7875932e80de4d710f8383424ce94.svg";
export { ForwardRef as ReactComponent };